module.exports = __webpack_public_path__ + "img/no-chat-messages.6371dc9c.svg";